const env = import.meta.env;

export const SUPABASE_URL = String(env.VITE_SUPABASE_URL ?? '').trim();
export const SUPABASE_ANON_KEY = String(env.VITE_SUPABASE_ANON_KEY ?? '').trim();
export const HAS_SUPABASE = Boolean(SUPABASE_URL && SUPABASE_ANON_KEY);
export const ALLOW_DEV_AUTH = Boolean(env.DEV && String(env.VITE_DEV_AUTH ?? '') === '1');
export const AUTH_MODE: 'supabase' | 'dev' | 'none' = HAS_SUPABASE
  ? 'supabase'
  : ALLOW_DEV_AUTH
    ? 'dev'
    : 'none';

export const GAME_SERVER_URL = String(env.VITE_GAME_SERVER_URL ?? '')
  .trim()
  .replace(/\/+$/, '');

export function apiUrl(path: string): string {
  return GAME_SERVER_URL ? `${GAME_SERVER_URL}${path}` : path;
}

export const BUILD_LABEL = 'VESPER // CHROMA-06';
